"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFlag = void 0;
var react_1 = require("react");
function useFlag(initialState) {
    if (initialState === void 0) { initialState = false; }
    var _a = react_1.useState(initialState), flag = _a[0], setFlag = _a[1];
    var setFlagTrue = function () { return setFlag(true); };
    var setFlagFalse = function () { return setFlag(false); };
    return [flag, setFlagTrue, setFlagFalse];
}
exports.useFlag = useFlag;
